import * as types from './_actionTypes';




export const checkAuthStart = () => ({
  type: types.CHECK_AUTH_START
});

export const checkAuthSuccess = (user) => ({
  type: types.CHECK_AUTH_SUCCESS,
  payload: user
});

export const checkAuthFailure = (error) => ({
  type: types.CHECK_AUTH_FAILURE,
  payload: error
});

export const loginRequest = (credentials) => ({
  type: types.LOGIN_REQUEST,
  payload: credentials
});

export const loginSuccess = (user) => ({
  type: types.LOGIN_SUCCESS,
  payload: { user }
});

export const loginFailure = (error) => ({
  type: types.LOGIN_FAILURE,
  payload: error
});

// _actions.js
export const logoutRequest = () => ({
  type: types.LOGOUT_REQUEST
});

export const logoutSuccess = () => ({
  type: types.LOGOUT_SUCCESS
});

export const logoutFailure = (error) => ({
  type: types.LOGOUT_FAILURE,
  payload: error
});

export const clearAuthState = () => ({
  type: types.CLEAR_AUTH_STATE,
});


export const clearError = () => ({
  type: types.CLEAR_ERROR
});

export const redirectTo = (path) => ({
  type: types.REDIRECT,
  payload: path
});

export const setInitialCheckDone = () => ({
  type: types.SET_INITIAL_CHECK_DONE
});
